// extracted by mini-css-extract-plugin
module.exports = {"prevButton":"HistorySlider_prevButton__3d2Xx","nextButton":"HistorySlider_nextButton__bmolP"};